<template>
    <div class="check-in">
        <div class="container">
            <div class="layout d-flex justify-center align-center">
                <div class="flex md10 lg10 xl7">
                    <div class="back-button mb-4">
                        <backButton/>
                    </div>
                    <checknInSuccess :transaction="transaction" v-if="isSuccess"/>
                    <checkInInfo @success="success" v-else=""/>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import backButton from '@/elements/BackButton'
    import checkInInfo from './checkInInfo'
    import checknInSuccess from './checkInSuccess'
    export default {
        components: {
            backButton,
            checkInInfo,
            checknInSuccess
        },
        data() {
            return {
                isSuccess: false,
                transaction: ''
            }
        },
        methods: {
            success(transaction) {
                this.isSuccess = !this.isSuccess
                this.transaction = transaction
            }
        },
        computed: {
            getCheckinData() {
                return this.$store.getters.getCheckinData
            },
        },
        created() {
            if(!Object.keys(this.getCheckinData).length) this.$router.push('/studios/dashboard')
        },
        beforeDestroy() {
            this.transaction = ''
            if(this.isSuccess) {
                this.$store.commit('UNSET_CHECKIN_DATA')
            }
        }
    }
</script>

